var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('output',[_c('pre',[_vm._v(_vm._s(_vm.output))])]),_c('button',{attrs:{"type":"click"},on:{"click":_vm.unauth}},[_vm._v("Unauth")]),_c('button',{attrs:{"type":"click"},on:{"click":_vm.auth}},[_vm._v("Auth")])])}
var staticRenderFns = []

export { render, staticRenderFns }